export const typeFromMime = (mime) => {
    if (mime.includes('image')) {
        return 'image';
    }
    if (mime.includes('video')) {
        return 'video';
    }
    if (mime.includes('audio')) {
        return 'audio';
    }
    if (mime.includes('pdf')) {
        return 'pdf';
    }
    return 'document';
};
export const rawFileToAsset = async ({ rawFile, isReplace = false }) => {
    const fileName = rawFile.name.split('.').shift();
    const aggregate_type = typeFromMime(rawFile.type);
    let data = {};
    let dimensions = '';
    if (aggregate_type == 'image') {
        dimensions = await imageDimensions(rawFile);
    }
    data = {
        size: rawFile.size,
        createdAt: new Date().toLocaleDateString('fr'),
        aggregate_type: aggregate_type,
        url: URL.createObjectURL(rawFile),
        extension: rawFile.name.split('.').pop(),
        mime_type: rawFile.type,
        dimensions: dimensions,
        alt: fileName,
        caption: fileName,
        rawFile,
        replace: false,
        upload: true,
    };
    if (isReplace) {
        data.replace = true;
        data.upload = false;
    }
    else {
        data.filename = fileName;
        data.replace = false;
        data.upload = true;
    }
    return data;
};
const imageDimensions = (file) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
        const { naturalWidth: width, naturalHeight: height } = img;
        resolve(`${width}x${height}`);
    };
    img.onerror = () => {
        useNotification({
            type: 'warning',
            message: 'Error',
            description: 'There was some problem with the image.',
        });
        reject('There was some problem with the image.');
    };
    img.src = URL.createObjectURL(file);
});
//# sourceMappingURL=utils.js.map